"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarGrid = void 0;
var date_1 = require("@internationalized/date");
var calendar_1 = require("@react-aria/calendar");
var i18n_1 = require("@react-aria/i18n");
var react_1 = __importDefault(require("react"));
var Calendar_styled_1 = require("./Calendar.styled");
var CalendarCell_1 = require("./CalendarCell");
function CalendarGrid(_a) {
    var state = _a.state, props = __rest(_a, ["state"]);
    var locale = (0, i18n_1.useLocale)().locale;
    var _b = (0, calendar_1.useCalendarGrid)(props, state), gridProps = _b.gridProps, headerProps = _b.headerProps, weekDays = _b.weekDays;
    // Get the number of weeks in the month so we can render the proper number of rows.
    var weeksInMonth = (0, date_1.getWeeksInMonth)(state.visibleRange.start, locale);
    return (react_1.default.createElement("table", __assign({}, gridProps, { "data-testid": "calendar-grid" }),
        react_1.default.createElement("thead", __assign({}, headerProps),
            react_1.default.createElement("tr", null, weekDays.map(function (day, index) { return (react_1.default.createElement(Calendar_styled_1.StyledCalendarTh, { key: index }, day)); }))),
        react_1.default.createElement("tbody", null, new Array(weeksInMonth).fill(undefined).map(function (_, weekIndex) { return (react_1.default.createElement("tr", { key: weekIndex }, state
            .getDatesInWeek(weekIndex)
            .map(function (date, i) {
            return date ? (react_1.default.createElement(CalendarCell_1.CalendarCell, { key: i, state: state, date: date })) : (react_1.default.createElement("td", { key: i }));
        }))); }))));
}
exports.CalendarGrid = CalendarGrid;
